import React from 'react';
import cn from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import UserSymbol from '../_partials/UserSymbol';
import { getUserType, getUserTypeId } from '../helpers';
import s from './BasicUserName.scss';
export var BasicUserName = React.memo(function (_a) {
    var user = _a.user, _b = _a.showSymbol, showSymbol = _b === void 0 ? true : _b, symbolOpensPopup = _a.symbolOpensPopup, symbolClassName = _a.symbolClassName, useCoreRibbon = _a.useCoreRibbon, usernameClassName = _a.usernameClassName, coreRibbonClassname = _a.coreRibbonClassname, dataHook = _a["data-hook"];
    var userType = getUserType(user);
    var isCoreUser = userType.includes('core');
    var showCoreBadge = isCoreUser && showSymbol && useCoreRibbon;
    return (React.createElement(BiLoggerContextProvider, { value: {
            typeid: getUserTypeId(user),
            itemid: user.userId,
        } },
        React.createElement("span", { className: usernameClassName !== null && usernameClassName !== void 0 ? usernameClassName : s['data-hook-wrapper'], "data-hook": dataHook }, user.username),
        showCoreBadge && (React.createElement(CoreBadge, { corePackage: userType, size: "large", className: cn(s['core-badge'], symbolClassName, coreRibbonClassname) })),
        showSymbol && !showCoreBadge && (React.createElement(UserSymbol, { userType: getUserType(user), className: symbolClassName, openUserSymbolPopup: symbolOpensPopup }))));
});
BasicUserName.displayName = 'BasicUserName';
export default BasicUserName;
//# sourceMappingURL=BasicUserName.js.map